<div class="card-header bg-light">
    <h3 class="card-title mb-0">
        <i class="fas fa-search pr-2"></i>
        Selecionar Questão Incidental
    </h3>
</div>

<div class="card-body wrapper">
    <div class="row mb-2">
        <div class="col-md-12 mb-2">
            <label for="filtro" class="mb-1">Filtrar por...</label>
            <input type="text" id="filtro" class="form-control form-control-sm"
                [(ngModel)]="filtro" [ngModelOptions]="{standalone: true}"
                (keyup)="aplicarFiltro()" placeholder="Identificador ou descrição" />
        </div>

        <div class="col-md-12 mb-2">
            <div class="mat-elevation-z1">
                <table mat-table [dataSource]="dataSource" matSortDisableClear matSort matSortActive="identificador"
                    matSortDirection="asc">

                    <ng-container matColumnDef="selecao">
                        <th mat-header-cell *matHeaderCellDef class="text-center"></th>
                        <td mat-cell *matCellDef="let element" class="text-center" (click)="$event.stopPropagation()">
                            <input type="checkbox" [checked]="selecionada?.id === element.id"
                                (change)="selecionarLinha(element)" />
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="id">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Id</th>
                        <td mat-cell *matCellDef="let element">{{ element.identificador }}</td>
                    </ng-container>

                    <ng-container matColumnDef="nome">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Nome</th>
                        <td mat-cell *matCellDef="let element">{{ element.descricao }}</td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="['selecao', 'id', 'nome']"></tr>
                    <tr mat-row *matRowDef="let row; columns: ['selecao', 'id', 'nome']"
                        (click)="selecionarLinha(row)"
                        [ngClass]="{'bg-light': selecionada?.id === row.id}"
                        style="cursor: pointer;">
                    </tr>
                </table>

                <h5 class="table-no-data" [hidden]="dataSource.data?.length > 0 || carregando">
                    Nenhuma questão incidental disponível para reaproveitamento
                </h5>

                <mat-paginator [pageSizeOptions]="[5, 10, 15]" showFirstLastButtons></mat-paginator>
            </div>
        </div>
    </div>
</div>

<div class="card-footer">
    <div class="d-flex justify-content-between w-100">
        <div class="btn-group">
            <button type="button" class="btn btn-primary btn-sm mr-1" (click)="confirmarSelecao()">
                <i class="fas fa-check"></i> Selecionar
            </button>
            <button type="button" class="btn btn-success btn-sm" (click)="novaQuestao()">
                <i class="fas fa-plus"></i> Novo
            </button>
        </div>
        <button type="button" class="btn btn-default btn-sm" (click)="cancelar()">
            <i class="fas fa-times"></i> Cancelar
        </button>
    </div>
</div>